<template>
  <div class="plupload">
    <!--选择附件-->
    <CloudButton :id="uploadId" :disabled="disabled" class="select-files" :title="i18n.t('list37')">
      <span class="iconfont iconshangchuan1"></span>
      <p v-if="tooltip">{{ i18n.t('message52') }}</p>
    </CloudButton>
    <!--:percentage.sync="percent[item.id ? item.id : 100]"-->
    <div class="upload-file" v-show="fileList.length !== 0">
      <CloudTag
        type="dot"
        closable
        color="primary"
        @on-close="deleteFile(item.id ? item.id : '', item)"
        v-for="(item, index) in fileList"
        :key="index"
      >
        {{ item.name }}
      </CloudTag>
    </div>
    <div class="instructions">
      <slot name="instructions"></slot>
    </div>
    <!-- <CloudSpin v-if="loading" :fix="true"></CloudSpin> -->
    <div class="progress" v-if="loading && showProgress">
      <Progress :percent="percent" />
    </div>
  </div>
</template>

<script>
import plupload from 'plupload';
import api from '@/api/setting/setting';
import bus from '@/components/CloudIView/components/cascader/bus';
import i18n from '@/i18n/i18n';

const { getFileInfo } = api;
export default {
  name: 'Plupload',
  props: {
    list: Array,
    clear: Object,
    uploadNow: Boolean,
    uploadId: {
      type: String,
      default: 'selectFiles',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Boolean,
      default: false,
    },
    maxSize: {
      type: Number,
      default: 50, //M
    },
    showProgress: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    clear(val) {
      if (val) {
        this.loading = false;
        this.fileList = [];
        this.attachments = [];
      }
    },
    list: {
      handler(val) {
        this.fileList = val ? val : [];
        let attlist = val.filter(item => !item.file);
        this.attachments = attlist ? attlist : [];
      },
      deep: true,
    },
  },
  data() {
    return {
      uploader: {},
      key: '',
      i18n,
      attachments: [],
      new_multipart_params: {},
      fileList: [],
      percent: 0,
      objectName: '',
      suffix: '',
      url: '',
      name: '',
      uploadList: [],
      loading: false,
      saveFlag: true, //是否执行on-upload
      firstFlag: false, //控制第一次上传不重复setOption
    };
  },
  methods: {
    deleteFile(id, fileOrEntry) {
      if (id) {
        const entry =
          fileOrEntry && fileOrEntry.file && fileOrEntry.id != null ? fileOrEntry : null;
        const plFile = entry ? entry.file : fileOrEntry;
        if (plFile && this.uploader) {
          this.uploader.removeFile(plFile);
        }
        const idx = this.fileList.findIndex(item => item.id === id);
        if (idx !== -1) {
          this.fileList.splice(idx, 1);
        }
        this.$emit('file-removed', id);
      } else {
        this.attachments.forEach((item, index) => {
          if (item.name === fileOrEntry.name) {
            this.fileList.splice(index, 1);
            this.attachments.splice(index, 1);
          }
        });
        this.$emit('update:list', this.attachments);
      }
    },
    async uploadFile(up, filename) {
      bus.$emit('startUpload', true);
      if (!this.uploader.files.length) {
        if (this.saveFlag) {
          this.$emit('on-upload', this.attachments);
        }
        bus.$emit('endUpload', false);
      } else {
        this.loading = true;
        let suffix;
        // let objectName = '';
        const { name } = this.uploader.files[0];
        if (this.uploader.files.length !== 0) {
          if (filename) {
            suffix = this.getSuffixNoPoint(filename);
          }
          // objectName = this.calculateObjectName(calName);
          const that = this;
          getFileInfo(suffix || name.substring(name.lastIndexOf('.') + 1)).then(file => {
            if (file) {
              const params = {
                Filename: suffix || name,
                key: `${file.data.dir}${suffix || name}`,
                policy: file.data.policy,
                OSSAccessKeyId: file.data.accessid,
                success_action_status: '200', // 让服务端返回200,不然，默认会返回204
                signature: file.data.signature,
              };
              that.uploader.setOption({
                url: file.data.host,
                multipart_params: params,
              });
              that.url = `${file.data.host}/${file.data.dir}`;
            }
            that.uploader.start();
          });
        }
      }
    },
    // 产生随机文件名
    randomString(len) {
      const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
      const maxPos = chars.length;
      let pwd = '';
      for (let i = 0; i < len; i += 1) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    getSuffix(filename) {
      const pos = filename.lastIndexOf('.');
      let suffix = '';
      if (pos !== -1) {
        suffix = filename.substring(pos);
      }
      return suffix;
    },
    getSuffixNoPoint(filename) {
      const pos = filename.lastIndexOf('.');
      let suffix = '';
      if (pos !== -1) {
        suffix = filename.substring(pos + 1);
      }
      return suffix;
    },
    calculateObjectName(filename) {
      const suffix = this.getSuffix(filename);
      return this.randomString(10) + suffix;
    },
    getDefaultList() {
      if (this.list.length !== 0) {
        const list = this._.cloneDeep(this.list);
        const arr = this.fileList.map(v => v.name);
        list.forEach(item => {
          if (arr.indexOf(item.name) === -1) {
            this.fileList.push(item);
          }
        });
        this.attachments = list;
      }
    },
    add(a, b) {
      return a + b / 4;
    },
  },
  mounted() {
    this.uploader = new plupload.Uploader({
      browse_button: this.uploadId,
      init: {
        FilesAdded: async (uploader, files) => {
          files.forEach(item => {
            if (item.size / Math.pow(1024, 2) > this.maxSize) {
              this.uploader.removeFile(item);
              this.$Message.error(i18n.t('new210') + this.maxSize + 'M');
              throw 'Error';
            }
            const name = this.$moment().format('YYYYMMDDHHmmss') + item.name;
            item.oldName = item.name;
            item.name = name;
            const entry = {
              name: item.oldName,
              type: item.type,
              id: item.id,
              file: item,
            };
            this.fileList.push(entry);
            this.$emit('files-added', entry);
          });
          if (this.uploadNow) {
            await this.uploadFile(uploader);
            // uploader.start();
          }
        },
        BeforeUpload: async (uploader, file) => {
          // if (this.firstFlag) {
          //   await this.uploadFile(uploader, file.name);
          // } else {
          //   this.firstFlag = true;
          // }
        },
        UploadProgress: (uploader, file) => {
          // this.$set(this.percent, file.id, file.percent);
          const singlePercent = Math.round((100 / this.fileList.length) * 10) / 10;
          const attachmentLength = this.attachments.length;
          this.percent = singlePercent * attachmentLength + file.percent / this.fileList.length;
          this.percent = Math.ceil(this.percent);
          if (this.percent > 100) {
            this.percent = 100;
          }
        },
        FileUploaded: (uploader, file, info) => {
          if (info.status === 200) {
            this.uploader.removeFile(file);
            this.uploader.stop();
            // this.$Message.success('上传成功');
            const obj = {
              url: this.url + file.name,
              name: file.oldName,
            };
            console.log(obj)
            this.attachments.push(obj);
            // 文件上传成功则更新list
            // 全部上传完毕再更新
            if (this.fileList.length === this.attachments.length) {
              this.percent = 100;
              this.firstFlag = false;
              this.loading = false;
              this.$emit('update:list', this.attachments);
              if (this.saveFlag) {
                this.$emit('on-upload', this.attachments);
              }
              bus.$emit('endUpload', false);
            } else {
              this.uploadFile();
            }
          } else {
            this.$Message.error('上传失败');
            this.loading = false;
          }
        },
      },
    });
    this.uploader.init();

    setTimeout(() => {
      this.getDefaultList();
    }, 0);
  },
};
</script>

<style lang="less">
.plupload {
  position: relative;

  .instructions {
    width: 500px;
    position: relative;
    margin-left: 0;
  }
}

.select-files {
  padding: 1px 15px 1px;
}

.upload-file {
  margin-top: 10px;

  .ivu-tag-primary {
    margin-top: 8px;
    display: flex;
    align-items: center;
  }

  .ivu-icon {
    position: absolute;
    top: 50%;
    margin-top: -7px;
    right: 10px;
  }

  .ivu-tag-text {
    display: inline-block;
    width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
  }
}

.upload-btn {
  margin-left: 20px;
}

.progress {
  position: absolute;
  top: 40px;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;

  .ivu-progress-outer {
    margin-left: 12px;
  }
}
</style>
